export enum ReportsUrlParams {
    dashboardId = 'dashboardId',
    studyId = 'studyId',
}
